import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

const addTransportAttachments = async ({ transportId, files }) => {
  return await Promise.allSettled(
    files.map((file) => {
      const formData = new FormData();
      formData.append('file', file.originFileObj);

      return request.post(
        `/HousingStock/transport/${transportId}/attachments`,
        formData,
        `При загрузке файла ${file.originFileObj.name} произошла ошибка`
      );
    })
  );
};

export const useAddTransportAttachments = () => {
  const queryClient = useQueryClient();
  const addMutation = useMutation(addTransportAttachments, {
    onSuccess: (_, { transportId }) => {
      queryClient.invalidateQueries(
        getQueryKeys.transportAttachments(transportId),
      );
    },
  });

  return {
    addAttachments: addMutation.mutateAsync,
    loading: addMutation.isLoading,
  };
};
